<script lang="ts">
	import { Device } from "luxedo-data"
	import { Reactivity } from "luxedo-reactivity"
	import { getCurrentUser, userRepo } from "../../../../../stores/UserStore.svelte"

	/**
	 * This component is rendered in the "Projectors" > "About" tab.
	 * This is intended to inform the user of an action they can take regarding their device.
	 */

	interface Props {
		device: Device
	}

	let { device }: Props = $props()

	$effect.pre(() => {
		Reactivity.useProps(device, [
			"password",
			"name",
			"eidos",
			"firmwareVersion",
			"isUpdating",
			"isOnline",
		])
	})

	let eidos = $derived(Reactivity.propOf(device, "eidos"))
	let isIR = $derived((eidos.projector?.connection_interface ?? null) == "IR")
	let isUserCommercial = $derived(userRepo.user?.hasPriv("commercial"))

	$inspect(eidos, isIR)

	function requestRS232Upgrade() {
		window.open("https://contact.gorgias.help/en-US/forms/g8pfexbq", "_blank")
	}
</script>

{#snippet prompt(title: string, description: string, buttonText: string, action: () => void)}
	<div class="device-prompt projector-section">
		<h3 class="setting-heading">{title}</h3>
		<p class="info">
			{description}
		</p>
		<button class="outline-button alt" onclick={action}> {buttonText} </button>
	</div>
{/snippet}

{#if isIR && !isUserCommercial}
	{@render prompt(
		"Projector Upgrade",
		"This device can use RS232 instead of Infrared for faster and more stable projector control. Click below to request an RS232 cable upgrade.",
		"Request Upgrade",
		requestRS232Upgrade,
	)}
{/if}

<style>
	.device-prompt {
		width: 100%;
		padding: 1rem;
		background-color: var(--color-bg-darker);
	}

	a {
		border-bottom: none;
	}

	.info {
		color: var(--color-text);
	}
</style>
